import { ChainId, SUPPORTED_CHAINS, SupportedChainsType } from './chains'

type AddressMap = { [chainId: number]: string }

type ChainAddresses = {
  factoryAddress: string
  multicallAddress: string
  quoterAddress: string
  nonfungiblePositionManagerAddress?: string
  routerAddress: string
}

export const THE_ADDRESSES: AddressMap = {
  [ChainId.BSC]: '0xF4C8E32EaDEC4BFe97E0F595AdD0f4450a863a11',
  [ChainId.OPBNB]: '0x9d94A7fF461e83F161c8c040E78557e31d8Cba72',
}

export const V1_FACTORY_ADDRESSES: AddressMap = {
  [ChainId.BSC]: '0xAFD89d21BdB66d00817d4153E055830B1c2B3970',
  [ChainId.OPBNB]: '0xFC1bC666A98703505534477E651A2470508C99A4',
}

export const V1_ROUTER_ADDRESSES: AddressMap = {
  [ChainId.BSC]: '0xd4ae6eca985340dd434d38f470accce4dc78d109',
  [ChainId.OPBNB]: '0x4E02acCD83C09EaF2ff4b8346ED6a33A7a369b47',
}

// BSC Fusion addresses
const BSC_ADDRESSES: ChainAddresses = {
  factoryAddress: '0x306F06C147f064A010530292A1EB6737c3e378e4',
  multicallAddress: '0x8089ED19D7CE5132003B9b135Bb4d8c3F36e3168',
  quoterAddress: '0xeA68020D6A9532EeC42D4dB0f92B83580c39b2cA',
  nonfungiblePositionManagerAddress: '0xa51ADb08Cbe6Ae398046A23bec013979816B77Ab',
  routerAddress: '0x327Dd3208f0bCF590A66110aCB6e5e6941A4EfA0'
}

// opBNB Fusion addresses
const OPBNB_ADDRESSES: ChainAddresses = {
  factoryAddress: '0x9e92b57bff702530A0C3bE9ff5fE2c24F95A91F6',
  multicallAddress: '0x2308BD5B1f66C32CC482254B4EE99cc7708d2e41',
  quoterAddress: '0xF15B76244C184b4CCD37F419e0F4591B3FAB9290',
  nonfungiblePositionManagerAddress: '0x8089ED19D7CE5132003B9b135Bb4d8c3F36e3168',
  routerAddress: '0x9356934eb3fBAE6274Eae6EfC905B292F04f0122'
}

export const CHAIN_TO_ADDRESSES_MAP: Record<SupportedChainsType, ChainAddresses> = {
  [ChainId.BSC]: BSC_ADDRESSES,
  [ChainId.OPBNB]: OPBNB_ADDRESSES,
}

/* V3 Contract Addresses */
export const FUSION_FACTORY_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].factoryAddress
    return memo
  }, {})
}

export const MULTICALL_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].multicallAddress
    return memo
  }, {})
}

export const FUSION_QUOTER_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].quoterAddress
    return memo
  }, {})
}

export const FUSION_ROUTER_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].routerAddress
    return memo
  }, {})
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    const nonfungiblePositionManagerAddress = CHAIN_TO_ADDRESSES_MAP[chainId].nonfungiblePositionManagerAddress
    if (nonfungiblePositionManagerAddress) {
      memo[chainId] = nonfungiblePositionManagerAddress
    }
    return memo
  }, {})
}

export const ROUTER_V1_ADDRESSES = (chainId: SupportedChainsType) => {
  return CHAIN_TO_ADDRESSES_MAP[chainId].routerAddress
}
